(function () {
  function initReadingProgress() {
    var fill = document.getElementById("jl-progress-fill");

    if (!fill) return;

    function update() {
      var docElem = document.documentElement;
      var docBody = document.body;

      var scrollTop = docElem.scrollTop || docBody.scrollTop;
      var scrollHeight = docElem.scrollHeight || docBody.scrollHeight;
      var viewportHeight = window.innerHeight || docElem.clientHeight;

      var scrollable = scrollHeight - viewportHeight;

      if (scrollable <= 0) {
        fill.style.width = "0%";
        return;
      }

      var scrollPercent = (scrollTop / scrollable) * 100;
      var clamped = Math.min(100, Math.max(0, scrollPercent));

      fill.style.width = clamped.toFixed(1) + "%";
    }

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    window.addEventListener("load", update);

    update();
  }

  function initShareButtons() {
    var buttons = document.querySelectorAll(".jl-single-share-btn");
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      button.addEventListener("click", async function () {
        var title = button.getAttribute("data-share-title") || document.title;
        var url = button.getAttribute("data-share-url") || window.location.href;
        var label = button.querySelector(".jl-single-share-btn__label");
        var originalLabel = label ? label.textContent : "";

        try {
          if (navigator.share) {
            await navigator.share({
              title: title,
              url: url,
            });

            return;
          }

          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(url);

            if (label) {
              label.textContent =
                button.getAttribute("data-share-copied-label") || "Copied";

              window.setTimeout(function () {
                label.textContent = originalLabel;
              }, 1800);
            }

            return;
          }

          window.prompt(
            button.getAttribute("data-share-copy-label") || "Copy this link",
            url,
          );
        } catch (error) {
          if (error && error.name === "AbortError") {
            return;
          }

          window.prompt(
            button.getAttribute("data-share-copy-label") || "Copy this link",
            url,
          );
        }
      });
    });
  }

  function init() {
    initReadingProgress();
    initShareButtons();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
